<template>
  <b-overlay :show="loading" class="animated">
    <v-server-table
      :columns="table_config.columns"
      :options="table_config.options"
      :ref="ref"
      :theme="theme"
      id="managed-lists-server-table"
      class="w-100"
    >
      <span slot="name" slot-scope="{ row }">
        {{ row.value }}
      </span>
      <template slot="actions">
        <a class="btn btn-warning px-1 py-0 text-white mr-1">
          <i class="fa fa-pencil"></i>
        </a>
        <a class="btn btn-danger px-1 py-0 text-white mr-1">
          <i class="fa fa-trash"></i>
        </a>
      </template>
    </v-server-table>
  </b-overlay>
</template>

<script>
import { ServerTable } from "vue-tables-2";
import AttributeListCollection from "@/collections/lab/AttributeListCollection";
import BaseServerTable from "@/components/shared/BaseServerTable";

export default {
  name: "AttributesListsServerTable",
  extends: BaseServerTable,
  components: {
    ServerTable
  },
  props: {
    collection: {
      type: Object,
      default: () => new AttributeListCollection()
    },
    show_columns: {
      type: Array,
      default: () => ["name", "actions"]
    },
    sortable: {
      type: Array,
      default: () => ["name"]
    },
    filterable: {
      type: Array,
      default: () => ["searchable"]
    }
  },
  data() {
    return {
      table_config: Object.assign(this.getDefaultTableConfig(), {
        options: {
          headers: {
            name: "Name",
            sub_attributes: "Sub - Attributes",
            actions: "Actions"
          },
          filterable: false
        }
      })
    };
  }
};
</script>
